import { Radar } from "lucide-react";
import { NAV_LINKS } from "@/data/exceptionHub";

const PRODUCTS = ["SmartContainer™", "CommodityBid™", "RFQ™", "FreightIQ™", "Inspection™", "Exception Hub™"];

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-100" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center h-9 w-9 rounded-xl bg-navy text-white"><Radar className="h-[18px] w-[18px]" strokeWidth={1.75} /></span>
              <div className="leading-none">
                <span className="text-[15px] font-bold text-navy font-heading tracking-tight">Exception Hub™</span>
                <span className="block text-[10px] text-ink-400 tracking-wide mt-0.5">DeMaxtore Workspace</span>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm text-ink-500 leading-relaxed">
              An intelligent Operations Command Center that provides complete visibility, confidence and proactive control across the entire DeMaxtore Workspace ecosystem.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-400">Navigate</p>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (<li key={l.href}><a href={l.href} className="text-sm text-ink-500 hover:text-navy transition-colors">{l.label}</a></li>))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-400">Workspace Products</p>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {PRODUCTS.map((p) => (<li key={p} className="text-sm text-ink-500">{p}</li>))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-ink-400">© {new Date().getFullYear()} DeMaxtore. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-ink-400">
            <a href="#top" className="hover:text-navy transition-colors">Privacy</a>
            <a href="#top" className="hover:text-navy transition-colors">Terms</a>
            <a href="#top" className="hover:text-navy transition-colors">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
};
